export const SEARCH_GENERIC_ENDPOINT_EXPERIMENT = {
    name: 'homepage_search_ads_from_generic_endpoint_2',
    paramName: 'loadFromGenericEndpoint',
    defaultValue: false,
};
